// Runs changelog detection once on client load: reads the per-client Dexie record,
// computes the next state, and decides whether to offer the popover. `.client` because
// IndexedDB (Dexie) does not exist during SSR/prerender. No `$api` dependency, so the
// cross-layer plugin ordering (layer plugins sort above root plugins) does not matter.
export default defineNuxtPlugin(() => {
	// Deferred past hydration: detect() fetches releases into the shared state when a
	// bump is pending, and the async layout/page chunks give it time to win the race,
	// making the footer link's v-if disagree with the server-rendered HTML.
	onNuxtReady(() => {
		const { detect } = useChangelog();
		detect().catch(() => {
			// Detection is best-effort sugar; never surface an error to the app.
		});
	});
});
